import { Action } from '@ngrx/store';
import { Progression } from '@ispm-shared/modules/common';

export enum PathwayActionTypes {
  UPDATE_PATHWAY_TEST_PROGRESSION = '[Pathways] Update Pathway Test Progression',
  FETCH_PATHWAY_TEST_PROGRESSION = '[Pathways] Fetch Pathway Test Progression',
  PATHWAY_PROGRESSION_RETRIEVED = '[Pathways] Pathway Progression Retrieved',
  SAVE_PATHWAY_SELECTION_STATE = '[Pathways] Complete Pathways Selection',
  SUCCESSFUlLY_SAVED_PATHWAY_SELECTION_STATE = '[Pathways] Pathway Selection State Saved',
  UPDATE_PATHWAY_TEST_FINAL_PROGRESSION = '[Pathways] Update Pathway Test Final Progression'
}

export class UpdateProgressionAction implements Action {
  readonly type = PathwayActionTypes.UPDATE_PATHWAY_TEST_PROGRESSION;
  constructor(public payload: { progression: Progression}) { }
}

export class FetchPathwayProgressionAction implements Action {
  readonly type = PathwayActionTypes.FETCH_PATHWAY_TEST_PROGRESSION;
}

export class PathwayProgressionRetrievedAction implements Action {
  readonly type = PathwayActionTypes.PATHWAY_PROGRESSION_RETRIEVED;
  constructor(public payload: { progression: Progression}) { }
}

export class SavePathwaySelectionStateAction implements Action {
  readonly type = PathwayActionTypes.SAVE_PATHWAY_SELECTION_STATE;
}

export class SuccessfullySavedPathwaySelectionStateAction implements Action {
  readonly type = PathwayActionTypes.SUCCESSFUlLY_SAVED_PATHWAY_SELECTION_STATE;
}

export class UpdateFinalProgressionAction implements Action {
  readonly type = PathwayActionTypes.UPDATE_PATHWAY_TEST_FINAL_PROGRESSION;
  constructor(public payload: { progression: Progression}) { }
}

export type PathwayProgressionActions =
  UpdateProgressionAction |
  FetchPathwayProgressionAction |
  PathwayProgressionRetrievedAction |
  SavePathwaySelectionStateAction |
  SuccessfullySavedPathwaySelectionStateAction |
  UpdateFinalProgressionAction;
